module.exports = {
  IN: 'in',
  OUT: 'out',
};
